export default "__VITE_ASSET__CCJWQjYH__"